import { useStore } from 'hooks/useStore';
import { AutoComplete } from 'primereact/autocomplete';
import { useRef } from 'react';

export const useSupplierForecastSearch = () => {
  const {
    SupplierForecastStore: {
      isSupplierForecastLoading,
      searchInput,
      filteredndc10SearchData,
      filterConceptSearchData,
      handleSearch,
      handleSearchInputChange,
      handleFilterConceptSearch,
      handleEnterKeyDownSearchInput,
    },
  } = useStore();

  const searchRef = useRef<AutoComplete>(null);

  return {
    isSupplierForecastLoading,
    searchRef,
    searchInput,
    filteredndc10SearchData,
    filterConceptSearchData,
    handleSearch,
    handleSearchInputChange,
    handleFilterConceptSearch,
    handleEnterKeyDownSearchInput,
  };
};
